<template>
    <div class="p-fluid">
        <label v-if="label" :for="label">{{ props.label }}:</label>
        <autocomplete v-model="selectedIncident" :id="label" :suggestions="incidents" :loading="loading" optionLabel="incident_number" placeholder="Start typing incident number..." dropdown @item-select="incidentSelected" @complete="filterIncidents" class="mb-1" />
        <small class="p-invalidIncidentNumber" v-if="invalidIncidentNumber">Use at least 5 characters.</small>
    </div>
</template>

<script setup>
/**
 * This component acts as an input field where users can be selected.
 * There will be an input section where you will type the incident number, and it will filter out the
 * incidents and give you the incident details.
 * This will be a flexible component and will return you incident details everytime an incident selected.
 */
import { ref, onMounted, watch } from 'vue';
import { storeToRefs } from 'pinia';

import { incidentStore } from '@/store/global-stores';

const emit = defineEmits(['incident-selected', 'update:modelValue']);

const invalidIncidentNumber = ref(false);

// Both props are not mandatory
const props = defineProps({
    label: String,
    modelValue: String,
});

// Store states
const { incident, incidents } = storeToRefs(incidentStore);

// Component states
const loading = ref(false);
const selectedIncident = ref(null);

/*
// Computed properties
const selectedIncidentsDetails = computed(() => {
    console.log('computed selectedIncidentsDetails', incident);
    console.log('computed selectedIncidentsDetails', selectedIncident);
    return {
        id: incident.id,
        incident_number: incident.incident_number
    };
});
*/

watch(
    () => props.modelValue,
    () => {
        if (!props.modelValue) {
            selectedIncident.value = null;
        }
    }
);

onMounted(() => {
    // Initially, it will load 10 users by default params
    //loadIncidents();
});

const loadIncidents = async () => {

    if (incident && incident.incident_number && typeof incident.incident_number === 'string') {

        if (incident.incident_number.length >= 5) {
            loading.value = true;
            await incidentStore.fetchIncidentList(incident.incident_number);
            loading.value = false;
            invalidIncidentNumber.value = false;
            selectedIncident.value = null;
        } else {
            invalidIncidentNumber.value = true;
            loading.value = false;
        }
    }
};

const incidentSelected = () => {
    // Emit out event of selected user details
    emit('incident-selected', selectedIncident.value);
    // After a user is selected clear the modelValue
    // selectedIncident.value = null;
    emit('update:modelValue', selectedIncident.value?.id);
};
const filterIncidents = async (event) => {
    // Filter string will be on query so use that in params.name to filter users
    incident.incident_number = event.query;

    await loadIncidents();
};
</script>
